import { render, staticRenderFns } from "./PieChartReport.vue?vue&type=template&id=3ae4f072&scoped=true"
import script from "./PieChartReport.vue?vue&type=script&lang=js"
export * from "./PieChartReport.vue?vue&type=script&lang=js"
import style0 from "./PieChartReport.vue?vue&type=style&index=0&id=3ae4f072&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae4f072",
  null
  
)

export default component.exports